import PropTypes from "prop-types";
import React from "react";

import Framed from "../Framed";

import * as styles from "./styles.module.scss";

const GalleryImage = ({ image }) => (
  <Framed style={"brown"}>
    <img src={image} className={styles.image} />
  </Framed>
);

GalleryImage.propTypes = {
  image: PropTypes.string.isRequired,
};

export default GalleryImage;
